import { ApiMutationConfig, LegacyTokenResponse } from 'api/types';
import { createApiEndpoint } from 'api/utils';
import { URLS } from 'config';

type GetLegacyTokenConfig = ApiMutationConfig<
  unknown,
  unknown,
  LegacyTokenResponse
>;

export const getLegacyToken = createApiEndpoint<GetLegacyTokenConfig>({
  url: `${URLS.app}/api/Users/Self/Token`,
  method: 'GET',
});
